import actions from "../../constants/actions";

export const loadSpaceReservations = () => {
    return {
        type: actions.SPACE_RESERVATIONS.LOAD_LIST,
        payload: {},
    };
};

export const cancelReservationBySlot = (id, date) => {
    return {
        type: actions.SPACE_RESERVATIONS.DELETE_SLOT,
        payload: {
            id,
            date,
        },
    };
};

export const cancelReservation = (id) => {
    return {
        type: actions.SPACE_RESERVATIONS.DELETE,
        payload: {
            id,
        },
    };
};

export const addReservation = (data) => {
    return {
        type: actions.SPACE_RESERVATIONS.CREATE,
        payload: {
            data,
        },
    };
};
